var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 104.8,
    cy: 283.993,
    fill: "#ffd6bd",
    r: 51.777
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.455 436.295c-2.761-50.262-44.735-90.525-95.655-90.525s-92.894 40.263-95.655 90.525c-.078 1.423.382 2.676 1.362 3.711s2.207 1.563 3.632 1.563h181.323c1.425 0 2.652-.528 3.632-1.563.978-1.035 1.439-2.289 1.361-3.711z",
    fill: "#72d561"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 407.2,
    cy: 283.993,
    fill: "#ffd6bd",
    r: 51.777
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.855 436.295c-2.762-50.262-44.734-90.525-95.655-90.525s-92.894 40.263-95.655 90.525c-.078 1.423.382 2.676 1.362 3.711s2.206 1.563 3.632 1.563h181.322c1.425 0 2.652-.528 3.632-1.563s1.441-2.289 1.362-3.711z",
    fill: "#fc685b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 253.637,
    cy: 330.19,
    fill: "#ffd6bd",
    r: 51.777
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.293 482.492c-2.762-50.262-44.735-90.525-95.655-90.525s-92.894 40.263-95.655 90.525c-.078 1.423.382 2.676 1.362 3.711.98 1.036 2.206 1.564 3.632 1.564h181.323c1.425 0 2.652-.528 3.632-1.564.978-1.035 1.439-2.288 1.361-3.711z",
    fill: "#64b5f6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 140.42,
    fill: "#fdb800",
    rx: 116.187,
    ry: 116.186,
    transform: "matrix(.994 -.109 .109 .994 -13.794 28.772)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 140.42,
    fill: "#ffda2d",
    rx: 81.096,
    ry: 81.096,
    transform: "matrix(.16 -.987 .987 .16 76.387 370.622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 92.219c0-4.418 3.582-8 8-8s8 3.582 8 8v6.862c2.358.451 4.616 1.243 6.719 2.324 3.552 1.823 6.593 4.437 8.87 7.586 2.589 3.573 1.791 8.567-1.781 11.156-3.573 2.589-8.567 1.791-11.156-1.781-.855-1.183-1.947-2.139-3.182-2.773-1.176-.604-2.548-.946-4.04-.946h-5.316c-2.436 0-4.656 1.003-6.27 2.617s-2.617 3.835-2.617 6.27 1.002 4.656 2.617 6.27c1.614 1.614 3.835 2.617 6.27 2.617h3.775c6.852 0 13.076 2.798 17.582 7.304 4.507 4.507 7.304 10.731 7.304 17.583s-2.798 13.076-7.304 17.583c-3.121 3.12-7.064 5.421-11.47 6.541v7.19c0 4.418-3.582 8-8 8s-8-3.582-8-8v-6.861c-2.358-.452-4.615-1.244-6.718-2.324-3.551-1.824-6.593-4.437-8.87-7.586-2.589-3.573-1.791-8.567 1.781-11.156s8.568-1.791 11.156 1.781c.855 1.183 1.947 2.139 3.182 2.773 1.176.604 2.548.945 4.04.945h5.316c2.435 0 4.655-1.002 6.27-2.617 1.614-1.615 2.617-3.835 2.617-6.27 0-2.436-1.003-4.656-2.617-6.27-1.615-1.614-3.835-2.617-6.27-2.617h-3.775c-6.852 0-13.076-2.798-17.582-7.304-4.506-4.507-7.304-10.73-7.304-17.583 0-6.852 2.798-13.075 7.304-17.583 3.121-3.12 7.064-5.421 11.47-6.541v-7.19z",
    fill: "#fdb800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTeam);
export default __webpack_public_path__ + "static/media/sales-team.9151738d00dd655f3fe2da1d036bc81b.svg";
export { ForwardRef as ReactComponent };